export default __webpack_public_path__ + "static/media/marine_corp_relief.37c69794.png";